import { render, staticRenderFns } from "./SecuserNew.vue?vue&type=template&id=799b984d"
import script from "./SecuserNew.vue?vue&type=script&lang=js"
export * from "./SecuserNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports